import React, { lazy, Suspense, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { storeBudgetDashboardServices } from "data/storeBudgetData";
import { ArrowBackRounded } from "@mui/icons-material";
import ListStoreBudget from "./ListStoreBudget/ListStoreBudget";
import CreateStoreBudget from "./createStoreBudget/CreateStoreBudget";
import StoreBudgetReport from "./StoreBudgetReport/StoreBudgetReport";


const Loader = () => (
  <Box textAlign="center" mt={4}>
    <Typography>Loading...</Typography>
  </Box>
);


export default function StoreBudgetTracker() {
  const navigate = useNavigate();
  const [currentPath, service] = useOutletContext();

  const tabComponents = {
      [storeBudgetDashboardServices.masters.types.report.key]: {
        ...storeBudgetDashboardServices.masters.types.report.key,
        component: <StoreBudgetReport />,
      },
      [storeBudgetDashboardServices.masters.types.store_budget.key]: {
            ...storeBudgetDashboardServices.masters.types.store_budget.key,
            component: <ListStoreBudget />,
      },
      [storeBudgetDashboardServices.masters.types.create_store_budget.key]: {
            ...storeBudgetDashboardServices.masters.types.create_store_budget.key,
            component: <CreateStoreBudget />,
          },
    }

  return (
    <Box width={"100%"} p={1}>
          <Box display="flex" alignItems="center" columnGap={1} mt={2}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <Typography variant="h5">{service?.name}</Typography>
          </Box>
          {tabComponents?.[currentPath]?.component}
    </Box>
  );
}
